import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot} from '@angular/router';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '~local/app/core/services/authentication.service';


export const loggedOutGuard: CanActivateChildFn = ($childRoute: ActivatedRouteSnapshot, $state: RouterStateSnapshot) => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);
    const initialUrl = router.url;

    return authenticationService.isAuthorized$.pipe(
        map($ => {
            if ($) {
                const destination = $childRoute.queryParams && typeof $childRoute.queryParams.returnUrl === 'string'
                    ? $childRoute.queryParams.returnUrl
                    : initialUrl === $state.url ? '' : initialUrl;

                console.warn('Redirecting to ' + destination);
                return router.parseUrl(destination);
            }
            return !$;
        }),
    );
}
